import type { FieldValidation } from '@rjsf/utils';
import { SynechronGithubPickerFormData } from './types';

export function parseRepoPickerUrl(
  url: string | undefined,
): SynechronGithubPickerFormData {
  if (!url) {
    return { repo: '', team: '', domain: '' };
  }

  try {
    const parsed = new URL(`https://${url}`);
    const params = new URLSearchParams(parsed.search);

    return {
      repo: params.get('repo') ?? '',
      team: params.get('team') ?? '',
      domain: params.get('domain') ?? '',
    };
  } catch {
    return { repo: '', team: '', domain: '' };
  }
}

export function getPickerErrors(
  data: Partial<SynechronGithubPickerFormData>,
): string[] {
  const errors: string[] = [];

  if (!data.repo || data.repo.trim() === '') {
    errors.push('Repository name is required');
  }

  if (data.repo && !/^[a-z0-9-]+$/.test(data.repo)) {
    errors.push(
      'Repository name can only contain lowercase letters, numbers, and hyphens',
    );
  }

  if (!data.team || data.team.trim() === '') {
    errors.push('Team is required');
  }

  if (!data.domain || data.domain.trim() === '') {
    errors.push('Domain is required');
  }

  return errors;
}

export const SynechronGithubPickerValidation = (
  value: string,
  validation: FieldValidation,
) => {
  if (!value) {
    validation.addError('Repository configuration is required');
    return;
  }

  const data = parseRepoPickerUrl(value);
  const errors = getPickerErrors(data);

  for (const error of errors) {
    validation.addError(error);
  }
};
